import React, { useContext, useRef, useState } from 'react';
import { TeApiContext, useSelector } from '@ecommerce/nest-ssr/common';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownMenu from 'layouts/header/search/dropdown-menu/dropdown-menu';
import Button from 'atomic/utilization/button';
import SearchOptionInterface from 'layouts/header/search/search-option.interface';
import Autosuggest from 'layouts/header/search/components/autosuggest';

import './search.scss';

const Search: React.FC = () => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const allCategorysOption: SearchOptionInterface = { id: 0, name: 'Wszystkie kategorie', url: '', slug: '', type: 'all' };
    const { options = [], selected } = useSelector(
        (state: { search: { options: SearchOptionInterface[]; selected: SearchOptionInterface; }; }) => state.search || {}
    );
    let items = [allCategorysOption, ...options.map(item => ({ ...item, type: 'department' }))];

    if (selected) {
        items = [selected, ...items];
    }

    const [option, setOption] = useState(selected
        ? {
            id: selected.id,
            name: selected.name,
            url: selected.url,
            slug: selected.slug,
            type: selected.type
        }
        : allCategorysOption);
    const [selectedValue, setSelectedValue] = useState<{ id: number; type: string; } | []>(selected ? { id: selected.id, type: selected.type } : []);

    const onSelect = (event: any): void => {
        const item = JSON.parse(event.target.dataset.item);

        setOption(item);
        setSelectedValue({ id: item.type === 'category' ? item.id : item.slug ?? '', type: item.type });

        if (item?.id === 0) {
            setSelectedValue([]);
        }
    };

    const dropdownToggle = (): void => setDropdownOpen(!dropdownOpen);

    const [searchValue, setSearchValue] = useState('');
    const formRef = useRef<any>(null);

    const onChange = (event: any, { newValue }: any): void => setSearchValue(newValue);

    const onSubmit = (): void => formRef.current.submit();

    const handleSubmit = (event: React.FormEvent): void => {
        if (searchValue.length === 0) {
            event.preventDefault();
        }
    };

    return (
        <div className={`search-content${api.getDevice() === 'desktop' ? '' : ' search-content--mobile'}`}>
            <form className="search-content__form" action="/site/szukaj/" method="get"
                ref={formRef} onSubmit={handleSubmit}
            >
                <div className="search-content__form__group">
                    <Autosuggest searchValue={searchValue} onSubmit={onSubmit} onChange={onChange}/>
                    <div className="search-content__form__group__categories">
                        <Dropdown className="search-content__form__group__categories__dropdown" onClick={dropdownToggle} alignRight={true}>
                            <Dropdown.Toggle variant="success">
                                {option.name}
                            </Dropdown.Toggle>
                            <DropdownMenu options={items} onSelect={onSelect} value={option.name}/>
                        </Dropdown>
                    </div>
                    <Button className="search-content__form__group__submit" type="submit" color="orange"
                        uppercase={true}
                    >
                        Szukaj
                    </Button>
                </div>
                <input id="search-context-input" type="hidden" value={JSON.stringify(selectedValue)}
                    name="contextId"
                />
            </form>
        </div>
    );
};

export default Search;
